import { useState, useEffect } from 'react';
import { Card, Statistic, Row, Col, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  ShoppingCartOutlined, CheckCircleOutlined,
  ClockCircleOutlined, WarningOutlined,
} from '@ant-design/icons';
import axios from 'axios';

const API = import.meta.env.VITE_API_BASE || '/api';
const token = () => localStorage.getItem('ar_token');
const h = () => ({ Authorization: 'Bearer ' + token() });

export default function HomePage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(API + '/arrival/stats', { headers: h() }).then(r => {
      if (r.data.success) setStats(r.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spin style={{ display: 'block', margin: '40vh auto' }} size="large" />;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2>欢迎使用到货签收平台</h2>
        <p style={{ color: '#666' }}>请通过左侧菜单选择功能模块</p>
      </div>
      <Row gutter={16}>
        <Col span={6}><Card hoverable onClick={() => navigate('/customer/arrival-sign?sign_status=unsigned')}><Statistic title="待签收" value={stats?.unsigned || 0} prefix={<ClockCircleOutlined />} valueStyle={{ color: '#faad14' }} /></Card></Col>
        <Col span={6}><Card hoverable onClick={() => navigate('/customer/arrival-sign?sign_status=signed')}><Statistic title="已签收" value={stats?.signed || 0} prefix={<CheckCircleOutlined />} valueStyle={{ color: '#52c41a' }} /></Card></Col>
        <Col span={6}><Card><Statistic title="总发货单" value={stats?.total || 0} prefix={<ShoppingCartOutlined />} /></Card></Col>
        <Col span={6}><Card hoverable onClick={() => navigate('/customer/arrival-sign?sign_status=over6days')}><Statistic title="超12天未签" value={stats?.over6days || 0} prefix={<WarningOutlined />} valueStyle={{ color: '#ff4d4f' }} /></Card></Col>
      </Row>
      <Card title="公告通知" style={{ marginTop: 24 }}>
        <p>系统升级：签收功能已支持爱签电子签章，小程序扫码签收同步上线。</p>
      </Card>
    </div>
  );
}
